import 'css-chunksrc/client/pages/costProfilesPage/menu/styles.scss';export default {
  "menu": "_menu_1x2zf_1",
  "icon": "_icon_1x2zf_21",
  "iconBox": "_iconBox_1x2zf_29"
};